import update from 'immutability-helper'
import {
  // PLOP_APPEND_PATTERN_ANCHOR_ACTIONS_IMPORT
  SUBMIT_LOGIN,
  SUBMIT_LOGIN_SUCCESS,
  SUBMIT_LOGIN_FAILURE,
  SUBMIT_LOGOUT_SUCCESS,
  CHECK_AUTH_STATUS_FAILURE,
  CHECK_AUTH_STATUS_SUCCESS,
  CREATE_PASSWORD,
  CREATE_PASSWORD_SUCCESS,
  CREATE_PASSWORD_FAILURE,
  CREATE_NEW_PASSWORD,
  CREATE_NEW_PASSWORD_SUCCESS,
  CREATE_NEW_PASSWORD_FAILURE,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
  CLEAR_COGNITO_STORE
} from '../actions/cognito'

const initialState = {
  // PLOP_APPEND_PATTERN_ANCHOR_INITIAL_REDUCER
  createPassword: {},
  createPasswordError: {},
  resetPassword: {},
  resetPasswordError: '',
  isAuthorized: false,
  initialAuthChecking: true,
  isLoading: false,
  user: {},
  error: {}
}

export default function cognito(state = initialState, action) {
  switch (action.type) {
    // PLOP_APPEND_PATTERN_ANCHOR_REDUCERS

    // submit login
    case SUBMIT_LOGIN:
      return update(state, {
        isLoading: { $set: true }
      })
    case SUBMIT_LOGIN_SUCCESS:
      return update(state, {
        isLoading: { $set: false },
        isAuthorized: { $set: true },
        user: { $set: action.loginData }
      })
    case SUBMIT_LOGIN_FAILURE:
      return update(state, {
        isLoading: { $set: false },
        error: { $set: action.error }
      })
    case SUBMIT_LOGOUT_SUCCESS:
      return update(state, {
        initialAuthChecking: { $set: false },
        isAuthorized: { $set: false }
      })
    case CHECK_AUTH_STATUS_SUCCESS:
      return update(state, {
        initialAuthChecking: { $set: false },
        isAuthorized: { $set: true },
        user: { $set: action.authData }
      })
    case CHECK_AUTH_STATUS_FAILURE:
      return update(state, {
        initialAuthChecking: { $set: false },
        isAuthorized: { $set: false },
        error: { $set: action.error }
      })
    case CREATE_PASSWORD:
    case CREATE_NEW_PASSWORD:
    case RESET_PASSWORD:
      return update(state, {
        isLoading: { $set: true }
      })
    case CREATE_PASSWORD_SUCCESS:
    case CREATE_NEW_PASSWORD_SUCCESS:
      return update(state, {
        createPassword: { $set: action.createPasswordData },
        isLoading: { $set: false }
      })
    case CREATE_PASSWORD_FAILURE:
    case CREATE_NEW_PASSWORD_FAILURE:
      return update(state, {
        isLoading: { $set: false },
        createPasswordError: { $set: action.error }
      })
    case RESET_PASSWORD_SUCCESS:
      return update(state, {
        isLoading: { $set: false },
        resetPassword: { $set: action.resetPasswordData }
      })
    case RESET_PASSWORD_FAILURE:
      return update(state, {
        isLoading: { $set: false },
        resetPasswordError: { $set: action.error }
      })
    case CLEAR_COGNITO_STORE:
      return update(state, {
        $set: initialState
      })
    default:
      return state
  }
}
